// extracted by mini-css-extract-plugin
export var bottomRightDock = "_20-0";